// NEW AGREEMENT
export const UPDATE_NEW_AGREEMENT = 'UPDATE_NEW_AGREEMENT'
export const RESET_NEW_AGREEMENT = 'RESET_NEW_AGREEMENT'

// NEW PURPOSE
export const UPDATE_NEW_PURPOSE = 'UPDATE_NEW_PURPOSE'
export const RESET_NEW_PURPOSE = 'RESET_NEW_PURPOSE'

// SELECTED AGREEMENT
export const UPDATE_SELECTED_AGREEMENT = 'UPDATE_SELECTED_AGREEMENT'
export const RESET_SELECTED_AGREEMENT = 'RESET_SELECTED_AGREEMENT'
export const UPDATE_AGREEMENT_PURPOSES = 'UPDATE_AGREEMENT_PURPOSES'

// SELECTED PURPOSE
export const UPDATE_SELECTED_PURPOSE = 'UPDATE_SELECTED_PURPOSE'
export const RESET_SELECTED_PURPOSE = 'RESET_SELECTED_PURPOSE'

// SELECTED REFS
export const UPDATE_SELECTED_REFS = 'UPDATE_SELECTED_REFS'
export const RESET_SELECTED_REFS = 'RESET_SELECTED_REFS'

// AGREEMENTS LIST
export const UPDATE_AGREEMENTS_LIST = 'UPDATE_AGREEMENTS_LIST'

// PURPOSE LIST
export const UPDATE_PURPOSES_LIST = 'UPDATE_PURPOSES_LIST'

// FILTERS
export const UPDATE_AGREEMENT_FILTERS = 'UPDATE_AGREEMENT_FILTERS'
export const UPDATE_PURPOSE_FILTERS = 'UPDATE_PURPOSE_FILTERS'

// SORTING
export const UPDATE_AGREEMENT_TABLE_SORT = 'UPDATE_AGREEMENT_TABLE_SORT'
export const UPDATE_PURPOSE_TABLE_SORT = 'UPDATE_PURPOSE_TABLE_SORT'

// USER
export const UPDATE_USER_TYPE = 'UPDATE_USER_TYPE'
export const UPDATE_USER = "UPDATE_USER";

// DATA
export const SET_STORES_LIST = 'SET_STORES_LIST';
export const SET_SUPPLIERS_LIST = 'SET_SUPPLIERS_LIST';


// WEBPACK FOOTER //
// ./src/redux-store/action-types.js